export default function componentOne() {
  console.log("Component One Functionality");
}